import { BRAND_KEYS, CHART_STRATEGIES, DEFAULT_BRAND } from "@outpave/ds";
import type { BrandIdentity } from "@outpave/ds";
import { resolveBrandIdentity as resolveIdentity } from "@outpave/branding";
import type { ThemeColors } from "../utils/themeContextHelper";

export { DEFAULT_CHART_STRATEGY, chartThirdIndex } from "@outpave/branding";

export function resolveBrandIdentity(
  companyColors: Partial<ThemeColors> | null,
  platformColors: Partial<ThemeColors> | null | undefined,
): BrandIdentity | undefined {
  return resolveIdentity(companyColors, platformColors, {
    base: BRAND_KEYS[DEFAULT_BRAND],
    chartStrategies: CHART_STRATEGIES,
  });
}
